import templateOnly from '@ember/component/template-only';

export default templateOnly<{
  Blocks: {
    header: [];
    content: [];
    footer?: [];
  };
}>();
